import {
  Checkbox as MUICheckbox,
  CheckboxProps as MUICheckboxProps,
  FormControlLabel,
  styled,
  SxProps,
  Theme,
} from '@mui/material';
import React from 'react';

interface CheckboxProps extends MUICheckboxProps {
  label?: string | React.ReactNode;
  alignItems?: 'flex-start' | 'center';
  sx?: SxProps<Theme>;
  ref?: React.Ref<any>;
}

export const Checkbox = ({
  label,
  alignItems,
  sx,
  ref,
  ...props
}: CheckboxProps) => {
  return (
    <CustomFormControlLabel
      sx={{
        alignItems: alignItems ? alignItems : 'center',
        ...sx,
      }}
      control={<MUICheckbox ref={ref} {...props} />}
      label={label || ''}
    />
  );
};

const CustomFormControlLabel = styled(FormControlLabel)(({ theme }) => ({
  '& .MuiFormControlLabel-label': {
    fontSize: theme.typography.body1.fontSize,
  },
  [theme.breakpoints.down('sm')]: {
    '& .MuiFormControlLabel-label': {
      fontSize: theme.typography.body2.fontSize,
    },
  },
}));
